import { render, staticRenderFns } from "./AdminBasePricePlans.vue?vue&type=template&id=d11164a0"
import script from "./AdminBasePricePlans.vue?vue&type=script&lang=js"
export * from "./AdminBasePricePlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports